import InventaireIndicateurs from "@/components/inventaire-indicateurs";
import InventaireHistoriqueModifications from "@/components/inventaire-historique-modifications";
import InventaireObservationAdmin from "@/components/inventaire-observation-admin";
import InventaireConfirmModal from "@/components/inventaire-confirm-modal";
import InventaireInfoModal from "@/components/inventaire-info-modal";
import { ecart as _ecart, ecartLabel as _ecartLabel, ecartClass as _ecartClass, errorMessage, toNumber, formatMoney as _formatMoney, formatSignedMoney as _formatSignedMoney } from '@/utils/inventaire-helpers'

export default {
    name: 'show-inventaire',
    components: {
        InventaireIndicateurs,
        InventaireHistoriqueModifications,
        InventaireObservationAdmin,
        InventaireConfirmModal,
        InventaireInfoModal,
    },
    props: [],
    data() {
        return {
            filter: "",
            perPage: 20,
            currentPage: 1,
            fields: [
                { key: 'numero', label: 'N\u00b0' },
                { key: 'article', label: 'Produit' },
                { key: 'quantite_numerique', label: 'Qt\u00e9 num\u00e9rique' },
                { key: 'quantite_physique', label: 'Qt\u00e9 physique' },
                { key: 'ecart', label: '\u00c9cart' },
                { key: 'prix_unitaire', label: 'Prix public' },
                { key: 'valeur_numerique', label: 'Co\u00fbt th\u00e9orique' },
                { key: 'valeur_physique', label: 'Valeur' },
                { key: 'valeur_ecart', label: '\u00c9cart financier' },
            ],
            localResultats: [],
            observationAdmin: '',
            loading: false,
            pageLoading: true,
            showSubmitModal: false,
            showAuthorizeModal: false,
            showRestoreModal: false,
            showInfoModal: false,
            infoModalTitle: 'Information',
            infoModalMessage: '',
        }
    },
    computed: {
        inventaire() {
            return this.$store.getters['inventaire'] || {}
        },
        canEdit() {
            return !this.isAdmin && !!this.inventaire.can_edit
        },
        canSubmit() {
            return this.canEdit && this.localResultats.length > 0 && this.localResultats.every(item => item.quantite_physique !== null && item.quantite_physique !== '' && item.quantite_physique !== undefined)
        },
        canRestore() {
            return this.isAdmin && !!this.inventaire.can_restore
        },
        canAuthorizeCorrection() {
            return this.isAdmin && !!this.inventaire.can_authorize_correction
        },
        canSaveObservation() {
            return this.observationAdmin && this.observationAdmin.trim().length > 0
        },
        recapValorisation() {
            return this.localResultats.reduce((acc, item) => {
                acc.total_valeur_numerique += toNumber(this.valeurNumerique(item))
                acc.total_valeur_physique += toNumber(this.valeurPhysique(item))
                acc.total_valeur_ecart += toNumber(this.valeurEcart(item))
                const ecartProduit = this.ecart(item)
                if (ecartProduit !== null && ecartProduit > 0) {
                    acc.ecart_positif += ecartProduit
                } else if (ecartProduit !== null && ecartProduit < 0) {
                    acc.ecart_negatif += ecartProduit
                }
                return acc
            }, {
                total_valeur_numerique: 0,
                total_valeur_physique: 0,
                total_valeur_ecart: 0,
                ecart_positif: 0,
                ecart_negatif: 0,
            })
        },
        indicateurs() {
            return [
                {
                    label: 'Valeur stock th\u00e9orique',
                    hint: 'Somme des valeurs th\u00e9oriques (qt\u00e9 num\u00e9rique \u00d7 prix public)',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_numerique) }],
                },
                {
                    label: '\u00c9cart produit',
                    hint: '',
                    cardClass: 'card-box-shadow',
                    lignes: [
                        { valeur: '+' + this.recapValorisation.ecart_positif, sousLabel: '\u00c9cart positif' },
                        { valeur: '' + this.recapValorisation.ecart_negatif, sousLabel: '\u00c9cart n\u00e9gatif' },
                    ],
                },
                {
                    label: 'Co\u00fbt physique',
                    hint: 'Somme des valeurs physiques (qt\u00e9 physique \u00d7 prix public)',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_physique) }],
                },
                {
                    label: '\u00c9cart financier',
                    hint: 'Diff\u00e9rence entre co\u00fbt physique et valeur stock th\u00e9orique',
                    cardClass: 'card-box-shadow',
                    lignes: [{ valeur: this.formatCurrency(this.recapValorisation.total_valeur_ecart) }],
                },
            ]
        },
        showIndicateurs() {
            return this.isAdmin && this.inventaire.statut === 'soumis'
        },
        showHistorique() {
            const modifications = this.inventaire.modifications || []
            return this.isAdmin && modifications.length > 0
        },
        isAdmin() {
            const role = this.$store.getters['activeRole'] || {}
            return role.nom === 'ROLE_ADMINISTRATEUR'
        },
        utilisateurId() {
            const auth = this.$store.getters['authInfo'] || {}
            return (auth.user && auth.user.id) || null
        },
    },
    mounted() {
        this.loadInventaire()
    },
    methods: {
        openInfoModal(message, title = 'Information') {
            this.infoModalMessage = message
            this.infoModalTitle = title
            this.showInfoModal = true
        },
        closeInfoModal() {
            this.showInfoModal = false
            this.infoModalMessage = ''
        },
        async loadInventaire() {
            this.pageLoading = true
            try {
                const inventaire = await this.$store.dispatch("getInventaire", this.$route.params.id)
                this.hydrateLocalState(inventaire)
            } catch (error) {
                this.openInfoModal(errorMessage(error, "Impossible de charger l'inventaire"), 'Erreur')
            } finally {
                this.pageLoading = false
            }
        },

        hydrateLocalState(inventaire) {
            const resultats = inventaire && inventaire.resultats ? inventaire.resultats : []
            this.localResultats = resultats.map(item => ({
                ...item,
                quantite_physique: item.quantite_physique !== null && item.quantite_physique !== undefined ? item.quantite_physique : item.nombre,
            }))
            this.observationAdmin = inventaire && inventaire.observation_admin ? inventaire.observation_admin : ''
        },

        ecart(item) {
            return _ecart(item.quantite_physique, item.quantite_numerique)
        },

        ecartLabel(item) {
            return _ecartLabel(this.ecart(item))
        },

        ecartClass(item) {
            return _ecartClass(this.ecart(item))
        },

        valeurEcartClass(value) {
            const numericValue = Number(value)
            if (!Number.isFinite(numericValue) || numericValue === 0) return 'badge badge-xs badge-success-light'
            return numericValue > 0 ? 'badge badge-xs badge-primary-light' : 'badge badge-xs badge-danger-light'
        },

        prixPublic(item) {
            return toNumber(item.prix_public !== null && item.prix_public !== undefined ? item.prix_public : item.prix_unitaire)
        },

        valeurNumerique(item) {
            if (item.valeur_numerique !== null && item.valeur_numerique !== undefined && item.valeur_numerique !== '') {
                return item.valeur_numerique
            }
            return toNumber(item.quantite_numerique) * this.prixPublic(item)
        },

        valeurPhysique(item) {
            if (item.quantite_physique === null || item.quantite_physique === '' || item.quantite_physique === undefined) {
                return null
            }
            return toNumber(item.quantite_physique) * this.prixPublic(item)
        },

        valeurEcart(item) {
            if (item.quantite_physique === null || item.quantite_physique === '' || item.quantite_physique === undefined) {
                return null
            }
            return (toNumber(item.quantite_physique) * this.prixPublic(item)) - (toNumber(item.quantite_numerique) * this.prixPublic(item))
        },

        formatMoney(value) {
            return _formatMoney(value, this.currencyLabel())
        },

        formatSignedMoney(value) {
            return _formatSignedMoney(value, this.currencyLabel())
        },

        currencyLabel() {
            if (this.currency_info && this.currency_info.principal_currency) {
                return this.currency_info.principal_currency
            }
            return this.principal_currency || ''
        },

        async saveDraft(redirectToList = false) {
            this.loading = true
            try {
                const resultats = this.localResultats.map(item => ({
                    resultat_id: item.id,
                    quantite_physique: item.quantite_physique,
                }))
                const response = await this.$store.dispatch('updateInventaireResultats', {
                    id: this.inventaire.id,
                    resultats,
                })
                this.hydrateLocalState(response.inventaire)
                if (redirectToList) {
                    this.navigateToInventaires()
                }
                return true
            } catch (error) {
                this.openInfoModal(errorMessage(error, 'Impossible d\u2019enregistrer le brouillon'), 'Erreur')
                return false
            } finally {
                this.loading = false
            }
        },
        openSubmitModal() {
            this.showSubmitModal = true
        },
        closeSubmitModal() {
            this.showSubmitModal = false
        },
        async confirmSubmit() {
            this.closeSubmitModal()
            const draftSaved = await this.saveDraft()
            if (!draftSaved) return
            this.loading = true
            try {
                const response = await this.$store.dispatch('soumettreInventaire', { id: this.inventaire.id, utilisateur_id: this.utilisateurId })
                if (response && response.success) {
                    this.navigateToInventaires()
                }
            } catch (error) {
                this.openInfoModal(errorMessage(error, 'Impossible de soumettre l\u2019inventaire'), 'Erreur')
            } finally {
                this.loading = false
            }
        },
        async saveObservation() {
            this.loading = true
            try {
                const response = await this.$store.dispatch('saveInventaireObservation', {
                    id: this.inventaire.id,
                    observation_admin: this.observationAdmin,
                })
                if (response && response.success) {
                    this.navigateToInventaires()
                }
            } catch (error) {
                this.openInfoModal(errorMessage(error, 'Impossible d\u2019enregistrer l\u2019observation'), 'Erreur')
            } finally {
                this.loading = false
            }
        },
        openAuthorizeModal() {
            this.showAuthorizeModal = true
        },
        closeAuthorizeModal() {
            this.showAuthorizeModal = false
        },
        async confirmAuthorizeCorrection() {
            this.closeAuthorizeModal()
            this.loading = true
            try {
                await this.$store.dispatch('autoriserCorrectionInventaire', this.inventaire.id)
                this.navigateToInventaires()
            } catch (error) {
                this.openInfoModal(errorMessage(error, 'Impossible d’autoriser la correction'), 'Erreur')
            } finally {
                this.loading = false
            }
        },
        openRestoreModal() {
            this.showRestoreModal = true
        },
        closeRestoreModal() {
            this.showRestoreModal = false
        },
        async confirmRestoreQuantities() {
            this.closeRestoreModal()
            this.loading = true
            try {
                const response = await this.$store.dispatch('retablirInventaire', this.inventaire.id)
                if (response && response.success) {
                    this.navigateToInventaires()
                }
            } catch (error) {
                this.openInfoModal(errorMessage(error, 'Impossible de rétablir les quantités'), 'Erreur')
            } finally {
                this.loading = false
            }
        },
        navigateToInventaires() {
            this.$router.replace({ path: '/inventaires' }).catch(() => {
                window.location.href = '/inventaires'
            })
        },
    }
}
